import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { firebase_app } from '../Config/Config';

const PrivateRoute = () => {
    const [currentUser, setCurrentUser] = useState(null);
    const [authenticated, setAuthenticated] = useState(false);
    const jwt_token = localStorage.getItem('token');

    useEffect(() => {
        const checkAuthState = () => {
            // Check Firebase authentication state
            /*firebase_app.auth().onAuthStateChanged(user => {
                setCurrentUser(user);
            });*/

            // Check local storage for authentication state
            const auth = JSON.parse(localStorage.getItem('authenticated'));
            setAuthenticated(auth);

            // Optionally, you can also set the current user from local storage if needed
            const user = JSON.parse(localStorage.getItem('currentUser'));
            setCurrentUser(user);
        };

        checkAuthState();
    }, []);

    return (
        currentUser !== null || authenticated || jwt_token ?
            <Outlet />
            :
            <Navigate to={`${process.env.PUBLIC_URL}/login`} />
    );
};

export default PrivateRoute;
